import React, {useState, useEffect} from "react";

import styles from "./DocumentTypes.module.css";

const DocumentTypes = (props) => {
  const [documentTypes, setDocumentTypes] = useState([]);

  const getDocumentTypes = async () => {
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/get-users`, options)
      .then((resp) => resp.json())
      .then((data) => {
        if (data.statusCode === 200) {
          let types = [];
          let allFiles = [];
          let allCsvFiles = [];

          data.result.output.forEach((element) => {
            types.push(element.Key.split("/")[1]);
            if (element.Key.split("/")[2]) {
              allCsvFiles.push({
                filename:
                  element.Key.split("/")[element.Key.split("/").length - 1],
                filetype: element.Key.split("/")[1],
                key: element.Key,
              });
            }
          });
          data.result.input.forEach((element) => {
            console.log(`Element ========> ${JSON.stringify(element)}`);
            if (element.Key.split("/")[1]) {
              allFiles.push({
                filename:
                  element.Key.split("/")[element.Key.split("/").length - 1],
                key: element.Key,
              });
            }
          });

          var uniqueTypes = types.filter(
            (value, index, types) =>
              types.indexOf(value) === index && value !== ""
          );

          console.log(`Types =====> ${types}`);
          console.log(`All Files =====> ${JSON.stringify(allFiles)}`);
          console.log(`All Csv Files =====> ${JSON.stringify(allCsvFiles)}`);

          props.updateSelectedType(uniqueTypes[0]);
          props.updateFiles(allFiles);
          props.updateCsvFiles(allCsvFiles);
          setDocumentTypes(uniqueTypes);
        }
      })
      .catch((error) => {
        console.log(`Error in getting document types =======> ${error}`);
      });
  };

  useEffect(() => {
    getDocumentTypes();
  }, []);

  useEffect(() => {
    if (props.refreshData === true) {
      getDocumentTypes();
      props.updateRefreshData(false);
    }
  }, [props.refreshData]);

  return (
    <div className={`${styles.documenttypes__Container}`}>
      {documentTypes.length > 0 &&
        documentTypes.map((documentType, index) => {
          return (
            <div
              key={index}
              className={`${styles.documenttypes__Item}`}
              onClick={() => props.updateSelectedType(documentType)}
              style={
                props.selectedType === documentType
                  ? {background: "#f1f5f9"}
                  : {}
              }
            >
              <h6>{documentType?.trim().replaceAll("_", " ")}</h6>
            </div>
          );
        })}
    </div>
  );
};

export default DocumentTypes;
